declare const __GX_SDK_VERSION__: string | undefined;

const sdkVersion =
	typeof __GX_SDK_VERSION__ === "string" ? __GX_SDK_VERSION__.trim() : "";

// Build scripts inject __GX_SDK_VERSION__ for published artifacts.
// Source-linked workspace usage may not inject defines, so keep a safe fallback.
export const SDK_VERSION = sdkVersion.length > 0 ? sdkVersion : "0.0.0-local";
